// Define the valid image and video file extensions
const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'mkv'];

const isImage = (fileUrl: string): boolean => {
    try {
        // Extract the file extension
        const extension = fileUrl.split('.').pop()?.toLowerCase();

        if (!extension) {
            // If the file has no extension, return false (neither image nor video)
            return false;
        }

        // Check if the extension matches any in the image or video lists
        if (imageExtensions.includes(extension)) {
            return true;
        }

        if (videoExtensions.includes(extension)) {
            return false;
        }

        // If it's neither in imageExtensions nor videoExtensions, assume it's not an image
        return false;
    } catch (error) {
        console.error('Error while checking file type:', error);
        return false;
    }
};

export default isImage;
